"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc"); // @ts-ignore no module typings


var schema = (0, _reactDesc.describe)({
  displayName: 'StepTracker'
});
schema.propTypes = {
  activeStep: _reactDesc.PropTypes.number.description('The active step number in the StepTracker, starting at 1'),
  steps: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.string).description('Array of strings with the title for each step in the tracker')
};
var _default = schema;
exports.default = _default;